// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host-context(.aulani) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
  /* For Mobile devices */
}
:host-context(.aulani) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.aulani) *:before, :host-context(.aulani) *:after {
  box-sizing: border-box;
}
:host-context(.aulani) *:focus {
  outline: 1px dotted #000;
}
:host-context(.aulani) html,
:host-context(.aulani) body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.aulani) body {
  width: 100%;
}
:host-context(.aulani) img {
  width: 100%;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5 {
  margin: 0;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) span,
:host-context(.aulani) a,
:host-context(.aulani) li,
:host-context(.aulani) p,
:host-context(.aulani) input,
:host-context(.aulani) textarea {
  font-family: inherit;
}
:host-context(.aulani) .clearfix {
  zoom: 1;
}
:host-context(.aulani) .clearfix:after {
  clear: both;
}
:host-context(.aulani) .clearfix:after, :host-context(.aulani) .clearfix:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.aulani) .float-left {
  float: left;
}
:host-context(.aulani) .float-right {
  float: right;
}
:host-context(.aulani) html,
:host-context(.aulani) body,
:host-context(.aulani) div,
:host-context(.aulani) span,
:host-context(.aulani) object,
:host-context(.aulani) iframe,
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) p,
:host-context(.aulani) blockquote,
:host-context(.aulani) pre,
:host-context(.aulani) abbr,
:host-context(.aulani) address,
:host-context(.aulani) address,
:host-context(.aulani) cite,
:host-context(.aulani) code,
:host-context(.aulani) del,
:host-context(.aulani) dfn,
:host-context(.aulani) em,
:host-context(.aulani) img,
:host-context(.aulani) ins,
:host-context(.aulani) kbd,
:host-context(.aulani) q,
:host-context(.aulani) samp,
:host-context(.aulani) small,
:host-context(.aulani) strong,
:host-context(.aulani) sub,
:host-context(.aulani) sup,
:host-context(.aulani) var,
:host-context(.aulani) b,
:host-context(.aulani) i,
:host-context(.aulani) dl,
:host-context(.aulani) dt,
:host-context(.aulani) dd,
:host-context(.aulani) ol,
:host-context(.aulani) ul,
:host-context(.aulani) li,
:host-context(.aulani) fieldset,
:host-context(.aulani) form,
:host-context(.aulani) label,
:host-context(.aulani) legend,
:host-context(.aulani) table,
:host-context(.aulani) caption,
:host-context(.aulani) tbody,
:host-context(.aulani) tfoot,
:host-context(.aulani) thead,
:host-context(.aulani) tr,
:host-context(.aulani) th,
:host-context(.aulani) td,
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) canvas,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section,
:host-context(.aulani) summary,
:host-context(.aulani) time,
:host-context(.aulani) mark,
:host-context(.aulani) audio,
:host-context(.aulani) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) img,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section {
  display: block;
}
:host-context(.aulani) ol,
:host-context(.aulani) ul {
  list-style: none;
}
:host-context(.aulani) blockquote,
:host-context(.aulani) q {
  quotes: none;
}
:host-context(.aulani) blockquote :before,
:host-context(.aulani) blockquote :after,
:host-context(.aulani) q :before,
:host-context(.aulani) q :after {
  content: none;
}
:host-context(.aulani) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.aulani) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.aulani) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.aulani) input,
:host-context(.aulani) select {
  vertical-align: middle;
}
:host-context(.aulani) address {
  font-style: normal;
}
:host-context(.aulani) input::-ms-clear {
  display: none;
}
:host-context(.aulani) button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.aulani) .details-on-file {
  background: #F4F2EF;
  padding: 36px 36px;
  border-top: thin solid #918F8C;
  border-bottom: thin solid #918F8C;
  margin-left: 0;
}
:host-context(.aulani) .details-on-file.all-sections-on-file {
  margin-left: 0;
}
:host-context(.aulani) .details-on-file.all-sections-on-file .details-collapse-wrap .details-heading span.di-checkmark {
  top: 3px;
}
:host-context(.aulani) .details-collapse-wrap .details-heading h2 {
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  letter-spacing: 0;
  font-family: "InspireTWDCLight";
  color: #382613;
  padding-left: 40px;
}
:host-context(.aulani) .details-collapse-wrap .details-heading span {
  font-family: Peptasia-ProfileMDX;
  font-size: 22px;
  color: #61941B;
  position: absolute;
  width: 28px;
  top: 10px;
}
:host-context(.aulani) .details-collapse-wrap .details-collapse {
  display: none;
  float: right;
  margin-top: 9px;
  cursor: pointer;
}
:host-context(.aulani) .details-collapse-wrap .details-collapse p {
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #382613;
  text-align: right;
  padding-right: 34px;
}
:host-context(.aulani) .details-collapse-wrap .details-collapse span {
  font-family: Peptasia-ProfileMDX;
  font-size: 20px;
  color: #382613;
  position: absolute;
  right: 0;
  top: 4px;
  width: 25px;
}
:host-context(.aulani) .details-collapse-bot {
  width: 128px;
  float: right;
  cursor: pointer;
}
:host-context(.aulani) .details-collapse-bot p {
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #382613;
  text-align: right;
  padding-right: 25px;
}
:host-context(.aulani) .details-collapse-bot span {
  font-family: Peptasia-ProfileMDX;
  font-size: 16px;
  color: #382613;
  position: absolute;
  right: 0;
  top: 5px;
  width: 20px;
}
@media only screen and (max-width: 767px) {
  :host-context(.aulani) .details-collapse-wrap .details-heading h2 {
    font-size: 18px;
    line-height: 27px;
    font-weight: 600;
    letter-spacing: 0;
    padding-left: 32px;
  }
  :host-context(.aulani) .details-collapse-wrap .details-heading span {
    top: 0px;
  }
  :host-context(.aulani) .details-collapse-wrap .details-collapse p {
    font-size: 14px;
    line-height: 21px;
    font-weight: 600;
    letter-spacing: 0;
  }
  :host-context(.aulani) .details-on-file {
    padding: 24px 24px 58px 24px;
    margin: 0;
  }
  :host-context(.aulani) .details-collapse-bot {
    float: left;
    margin-top: 24px;
  }
  :host-context(.aulani) .details-collapse-bot p {
    font-size: 14px;
    line-height: 21px;
    font-weight: 600;
    letter-spacing: 0;
  }
  :host-context(.aulani) .details-collapse-bot span.di {
    position: absolute;
    left: 0;
    top: 2px;
    width: 20px;
  }
}
@media (min-width: 767px) {
  :host-context(.aulani) .details-collapse-wrap .details-heading {
    float: left;
    width: 75%;
    margin: 0 0 4px 0;
  }
  :host-context(.aulani) .details-collapse-wrap .details-heading h2 {
    font-size: 24px;
    line-height: 32px;
    font-weight: 600;
    letter-spacing: 0;
    padding-left: 40px;
  }
  :host-context(.aulani) .details-collapse-wrap .details-heading span {
    font-size: 26px;
    width: 33px;
    top: 1px;
  }
  :host-context(.aulani) .details-collapse-wrap .details-collapse {
    display: block;
    margin-top: 0;
  }
  :host-context(.aulani) .details-collapse-bot {
    display: none;
  }
}

:host-context(.wdw) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
}
:host-context(.wdw) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.wdw) *:before, :host-context(.wdw) *:after {
  box-sizing: border-box;
}
:host-context(.wdw) *:focus {
  outline: 1px dotted #000;
}
:host-context(.wdw) html,
:host-context(.wdw) body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.wdw) body {
  width: 100%;
}
:host-context(.wdw) img {
  width: 100%;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5 {
  margin: 0;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) span,
:host-context(.wdw) a,
:host-context(.wdw) li,
:host-context(.wdw) p,
:host-context(.wdw) input,
:host-context(.wdw) textarea {
  font-family: inherit;
}
:host-context(.wdw) .clearfix {
  zoom: 1;
}
:host-context(.wdw) .clearfix:after {
  clear: both;
}
:host-context(.wdw) .clearfix:after, :host-context(.wdw) .clearfix:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.wdw) .float-left {
  float: left;
}
:host-context(.wdw) .float-right {
  float: right;
}
:host-context(.wdw) html,
:host-context(.wdw) body,
:host-context(.wdw) div,
:host-context(.wdw) span,
:host-context(.wdw) object,
:host-context(.wdw) iframe,
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) p,
:host-context(.wdw) blockquote,
:host-context(.wdw) pre,
:host-context(.wdw) abbr,
:host-context(.wdw) address,
:host-context(.wdw) address,
:host-context(.wdw) cite,
:host-context(.wdw) code,
:host-context(.wdw) del,
:host-context(.wdw) dfn,
:host-context(.wdw) em,
:host-context(.wdw) img,
:host-context(.wdw) ins,
:host-context(.wdw) kbd,
:host-context(.wdw) q,
:host-context(.wdw) samp,
:host-context(.wdw) small,
:host-context(.wdw) strong,
:host-context(.wdw) sub,
:host-context(.wdw) sup,
:host-context(.wdw) var,
:host-context(.wdw) b,
:host-context(.wdw) i,
:host-context(.wdw) dl,
:host-context(.wdw) dt,
:host-context(.wdw) dd,
:host-context(.wdw) ol,
:host-context(.wdw) ul,
:host-context(.wdw) li,
:host-context(.wdw) fieldset,
:host-context(.wdw) form,
:host-context(.wdw) label,
:host-context(.wdw) legend,
:host-context(.wdw) table,
:host-context(.wdw) caption,
:host-context(.wdw) tbody,
:host-context(.wdw) tfoot,
:host-context(.wdw) thead,
:host-context(.wdw) tr,
:host-context(.wdw) th,
:host-context(.wdw) td,
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) canvas,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section,
:host-context(.wdw) summary,
:host-context(.wdw) time,
:host-context(.wdw) mark,
:host-context(.wdw) audio,
:host-context(.wdw) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) img,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section {
  display: block;
}
:host-context(.wdw) ol,
:host-context(.wdw) ul {
  list-style: none;
}
:host-context(.wdw) blockquote,
:host-context(.wdw) q {
  quotes: none;
}
:host-context(.wdw) blockquote :before,
:host-context(.wdw) blockquote :after,
:host-context(.wdw) q :before,
:host-context(.wdw) q :after {
  content: none;
}
:host-context(.wdw) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.wdw) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.wdw) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.wdw) input,
:host-context(.wdw) select {
  vertical-align: middle;
}
:host-context(.wdw) address {
  font-style: normal;
}
:host-context(.wdw) input::-ms-clear {
  display: none;
}
:host-context(.wdw) button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.wdw) .details-on-file {
  background: #EBF6FC;
  padding: 24px 10px 30px;
  margin-top: 0;
}
:host-context(.wdw) .details-collapse-wrap .details-heading h2 {
  font-size: 24px;
  line-height: 48px;
  font-weight: 300;
  letter-spacing: 0;
  font-family: "InspireTWDCLight";
  color: #253B56;
  padding-left: 40px;
}
:host-context(.wdw) .details-collapse-wrap .details-heading span {
  font-family: Peptasia-ProfileMDX;
  font-size: 26px;
  color: #61941B;
  position: absolute;
  width: 33px;
  top: 9px;
  height: 27px;
}
:host-context(.wdw) .details-collapse-wrap .details-collapse {
  display: none;
  float: right;
  width: 120px;
  margin-top: 9px;
  cursor: pointer;
}
:host-context(.wdw) .details-collapse-wrap .details-collapse p {
  font-size: 12px;
  line-height: 28px;
  font-weight: 700;
  letter-spacing: 0;
  font-family: "InspireTWDCHeavy";
  color: #253B56;
  text-align: right;
  padding-right: 24.5px;
}
:host-context(.wdw) .details-collapse-wrap .details-collapse span {
  font-family: Peptasia-ProfileMDX;
  font-size: 16px;
  color: #253B56;
  position: absolute;
  right: 0;
  top: 4px;
  height: 16px;
}
:host-context(.wdw) .details-collapse-bot {
  width: 120px;
  float: right;
  cursor: pointer;
}
:host-context(.wdw) .details-collapse-bot p {
  font-size: 12px;
  line-height: 28px;
  font-weight: 700;
  letter-spacing: 0;
  font-family: "InspireTWDCHeavy";
  color: #253B56;
  text-align: right;
  padding-right: 25px;
}
:host-context(.wdw) .details-collapse-bot span {
  font-family: Peptasia-ProfileMDX;
  font-size: 16px;
  color: #253B56;
  position: absolute;
  right: 0;
  top: 5px;
  height: 16px;
}
@media (min-width: 767px) {
  :host-context(.wdw) .details-on-file {
    padding: 24px 40px 30px;
  }
  :host-context(.wdw) .details-collapse-wrap .details-heading {
    float: left;
    width: calc(100% - 120px);
  }
  :host-context(.wdw) .details-collapse-wrap .details-collapse {
    display: block;
  }
  :host-context(.wdw) .details-collapse-bot {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/details-on-file/details-on-file.component.scss","webpack://./src/assets/style/theme/index.scss","webpack://./src/assets/style/abstracts/variables.scss","webpack://./src/assets/style/abstracts/functions.scss","webpack://./src/assets/style/abstracts/mixins.scss","webpack://./src/assets/style/base/global.scss","webpack://./src/assets/style/base/reset.scss","webpack://./src/app/details-on-file/details-on-file.component.aulani.scss","webpack://./src/assets/style/base/font.scss","webpack://./src/assets/style/base/colors.scss","webpack://./src/app/details-on-file/details-on-file.component.wdw.scss"],"names":[],"mappings":"AAAA;ECAA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;EC8FA,uBAAA;APzDA;AK9BA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;ALgCJ;AK9BI;EAEI,sBAAA;AL+BR;AK5BI;EACI,wBAAA;AL8BR;AK1BA;;EAEI,SAAA;EACA,iBAAA;AL4BJ;AKzBA;EACI,WAAA;AL2BJ;AKxBA;EACI,WAAA;AL0BJ;AKvBA;;;;;EAKI,SAAA;ALyBJ;AKtBA;;;;;;;;;;;;EAYI,oBAAA;ALwBJ;AKrBA;EACI,OAAA;ALuBJ;AKrBI;EACI,WAAA;ALuBR;AKpBI;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ALqBR;AKjBA;EACI,WAAA;ALmBJ;AKhBA;EACI,YAAA;ALkBJ;AMlGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;ANoGJ;AMjGA;;;;;;;;;;;;EAYI,cAAA;ANmGJ;AMhGA;;EAEI,gBAAA;ANkGJ;AM/FA;;EAEI,YAAA;ANiGJ;AM/FI;;;;EAEI,aAAA;ANmGR;AM/FA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;ANiGJ;AM9FA;EACI,yBAAA;EACA,iBAAA;ANgGJ;AM7FA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AN+FJ;AM5FA;;EAEI,sBAAA;AN8FJ;AM3FA;EACI,kBAAA;AN6FJ;AMzFI;EACI,aAAA;AN2FR;AMvFA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANyFJ;AMpFQ;EACI,gBAAA;EACA,cAAA;ANsFZ;AMlFY;EACI,cAAA;ANoFhB;AOtPA;EACI,mBAAA;EACA,kBAAA;EACA,8BNcoB;EMbpB,iCNaoB;EMZpB,cAAA;APwPJ;AOtPI;EACI,cAAA;APwPR;AOpPgB;EACI,QAAA;APsPpB;AO7OQ;EHLJ,eGMsB;EHLtB,iBGK4B;EHJ5B,gBGIkC;EHHlC,iBAJqE;EGQ7D,+BC3Ba;ED4Bb,cNFgB;EMGhB,kBAAA;APkPZ;AO/OQ;EACI,gCAAA;EACA,eAAA;EACA,cEwCW;EFvCX,kBAAA;EACA,WAAA;EACA,SAAA;APiPZ;AO7OI;EACI,aAAA;EHNJ,YAAA;EGQI,eAAA;EACA,eAAA;AP+OR;AO7OQ;EH5BJ,eG6BsB;EH5BtB,iBG4B4B;EH3B5B,gBG2BkC;EH1BlC,iBAJqE;EG+B7D,+BC9Ca;ED+Cb,cNzBgB;EM0BhB,iBAAA;EACA,mBAAA;APkPZ;AO/OQ;EACI,gCAAA;EACA,eAAA;EACA,cNjCgB;EMkChB,kBAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;APiPZ;AO5OA;EACI,YAAA;EACA,YAAA;EACA,eAAA;AP8OJ;AO5OI;EHrDA,eGsDkB;EHrDlB,iBGqDwB;EHpDxB,gBGoD8B;EHnD9B,iBAJqE;EGwDjE,+BCvEiB;EDwEjB,cNlDoB;EMmDpB,iBAAA;EACA,mBAAA;APiPR;AO9OI;EACI,gCAAA;EACA,eAAA;EACA,cN1DoB;EM2DpB,kBAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;APgPR;AO3OA;EAGY;IH5ER,eG6E0B;IH5E1B,iBG4EgC;IH3EhC,gBG2EsC;IH1EtC,iBAJqE;IG+EzD,kBAAA;EP8Od;EO3OU;IACI,QAAA;EP6Od;EOxOU;IHvFR,eGwF0B;IHvF1B,iBGuFgC;IHtFhC,gBGsFsC;IHrFtC,iBAJqE;EJsUvE;EOxOE;IACI,4BAAA;IACA,SAAA;EP0ON;EOvOE;IACI,WAAA;IACA,gBAAA;EPyON;EOvOM;IHtGJ,eGuGsB;IHtGtB,iBGsG4B;IHrG5B,gBGqGkC;IHpGlC,iBAJqE;EJoVvE;EOzOM;IACI,kBAAA;IACA,OAAA;IACA,QAAA;IACA,WAAA;EP2OV;AACF;AOtOA;EAEQ;IHzGJ,WAAA;IG2GQ,UAAA;IACA,iBAAA;EPuOV;EOrOU;IH3HR,eG4H0B;IH3H1B,iBG2HgC;IH1HhC,gBG0HsC;IHzHtC,iBGyH2C;IAC/B,kBAAA;EP0Od;EOvOU;IACI,eAAA;IACA,WAAA;IACA,QAAA;EPyOd;EOrOM;IACI,cAAA;IACA,aAAA;EPuOV;EOnOE;IACI,aAAA;EPqON;AACF;;AAtYA;ECJA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;ANgbA;AKzaA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;AL2aJ;AKzaI;EAEI,sBAAA;AL0aR;AKvaI;EACI,wBAAA;ALyaR;AKraA;;EAEI,SAAA;EACA,iBAAA;ALuaJ;AKpaA;EACI,WAAA;ALsaJ;AKnaA;EACI,WAAA;ALqaJ;AKlaA;;;;;EAKI,SAAA;ALoaJ;AKjaA;;;;;;;;;;;;EAYI,oBAAA;ALmaJ;AKhaA;EACI,OAAA;ALkaJ;AKhaI;EACI,WAAA;ALkaR;AK/ZI;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ALgaR;AK5ZA;EACI,WAAA;AL8ZJ;AK3ZA;EACI,YAAA;AL6ZJ;AM7eA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;AN+eJ;AM5eA;;;;;;;;;;;;EAYI,cAAA;AN8eJ;AM3eA;;EAEI,gBAAA;AN6eJ;AM1eA;;EAEI,YAAA;AN4eJ;AM1eI;;;;EAEI,aAAA;AN8eR;AM1eA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AN4eJ;AMzeA;EACI,yBAAA;EACA,iBAAA;AN2eJ;AMxeA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AN0eJ;AMveA;;EAEI,sBAAA;ANyeJ;AMteA;EACI,kBAAA;ANweJ;AMpeI;EACI,aAAA;ANseR;AMleA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANoeJ;AM/dQ;EACI,gBAAA;EACA,cAAA;ANieZ;AM7dY;EACI,cAAA;AN+dhB;AUloBA;EACI,mBAAA;EACA,uBAAA;EACA,aAAA;AVooBJ;AU/nBQ;ENUJ,eMTsB;ENUtB,iBMV4B;ENW5B,gBMXkC;ENYlC,iBMZuC;EAC/B,+BFZa;EEab,cTRa;ESSb,kBAAA;AVooBZ;AUjoBQ;EACI,gCAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;AVmoBZ;AU/nBI;EACI,aAAA;ENQJ,YAAA;EMLI,YAAA;EACA,eAAA;EACA,eAAA;AVgoBR;AU9nBQ;ENhBJ,eMiBsB;ENhBtB,iBMgB4B;ENf5B,gBMekC;ENdlC,iBMcuC;EAC/B,+BFpCa;EEqCb,cTlCa;ESmCb,iBAAA;EACA,qBAAA;AVmoBZ;AUhoBQ;EACI,gCAAA;EACA,eAAA;EACA,cT1Ca;ES2Cb,kBAAA;EACA,QAAA;EACA,QAAA;EACA,YAAA;AVkoBZ;AU7nBA;EACI,YAAA;EACA,YAAA;EACA,eAAA;AV+nBJ;AU7nBI;ENzCA,eM0CkB;ENzClB,iBMyCwB;ENxCxB,gBMwC8B;ENvC9B,iBMuCmC;EAC/B,+BF7DiB;EE8DjB,cT3DiB;ES4DjB,iBAAA;EACA,mBAAA;AVkoBR;AU/nBI;EACI,gCAAA;EACA,eAAA;EACA,cTnEiB;ESoEjB,kBAAA;EACA,QAAA;EACA,QAAA;EACA,YAAA;AVioBR;AU7nBA;EACI;IACI,uBAAA;EV+nBN;EU3nBM;INrDJ,WAAA;IMuDQ,yBAAA;EV6nBV;EU1nBM;IACI,cAAA;EV4nBV;EUxnBE;IACI,aAAA;EV0nBN;AACF","sourcesContent":[":host-context(.aulani) {\r\n    @import './details-on-file.component.aulani.scss';\r\n}\r\n\r\n:host-context(.wdw) {\r\n    @import './details-on-file.component.wdw.scss';\r\n}\r\n","/* WDW COLOR CODE */\r\n\r\n$page-background: #E8EDF0;\r\n$primary-color: #FFF;\r\n$primary-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);\r\n$secondary-color: #0470AB;\r\n$wdw-primary-message-text-color: #78899E;\r\n$wdw-primary-text-color: #253B56;\r\n$wdw-h3-heading: #424B5A;\r\n$primary-border: thin solid #D8D8D8;\r\n$primary-wdw-link: #1994D7;\r\n$secondary-wdw-link: #1B96D5;\r\n$wdw-message-span: #130026;\r\n$wdw-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$wdw-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$wdw-breadcrumbs-next-color: #73A4BF;\r\n$wdw-disabled-color: #BADFF3;\r\n\r\n/* AULANI COLOR CODE */\r\n$papaya-whitebg-color: #D04901;\r\n$papaya-greybg-color: #B73C00;\r\n$aulani-link-color: #B73C00;\r\n$primary-aulani-border: thin solid #918F8C;\r\n$aulani-border-color: #918F8C;\r\n$aulani-secondary-text-color: #867F77;\r\n$border-background: #FFF;\r\n$primary-aulani-link: #D04901;\r\n$secondary-aulani-link: #D24B00;\r\n$aulani-primary-text-color: #382613;\r\n$aulani-warm-grey-color: #69645E;\r\n$primary-info-text: #8294AA;\r\n$secondary-button-background: #F3EEE6;\r\n$radio-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 15%, #DBDBDB 89%, #FBFBFB 100%);\r\n$footer-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 14%, #DBDBDB 95%, #FBFBFB 100%);\r\n$aulani-hover-link: #B14308;\r\n$aulani-border: radial-gradient($aulani-border-color 0%, #FFF 100%);\r\n$aulani-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$aulani-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$aulani-error-text: #5C4830;\r\n$error-label-color: #FF4605;\r\n$aulani-text-disabed-color: #EFB698;\r\n\r\n$default-button-border: #0079BC;\r\n$default-text-color: #00233C;\r\n$hover-button-border: #006096;\r\n$active-button-border: #083C5D;\r\n$disabled-button-border: #B7E4F7;\r\n","/**\r\n * variables.scss\r\n * Contains the sitewide variables\r\n */\r\n\r\n/**\r\n * Breakpoints variables\r\n */\r\n\r\n$breakpoints: (\r\n    x-small: 0,\r\n    mobile: 320px,\r\n    tablet: 768px,\r\n    desktop: 1024px\r\n);\r\n\r\n$orientations: (\r\n    portrait: portrait,\r\n    landscape: landscape\r\n);\r\n\r\n/**\r\n * Colors variables\r\n */\r\n\r\n$colors: (\r\n    'transparent': transparent,\r\n);\r\n\r\n/**\r\n * z-index variables\r\n */\r\n\r\n$zindex: (\r\n    'base': 1,\r\n    'menu': 2,\r\n    'overlay': 3,\r\n    'modal': 4,\r\n    'toast': 5\r\n);\r\n","/**\r\n * function.scss\r\n * Contains the sitewide functions\r\n */\r\n\r\n@function colors($color) {\r\n    @if not map-has-key($colors, $color) {\r\n        @warn 'No color found for `#{$color}`.';\r\n    }\r\n    \r\n    @return map-get($colors, $color);\r\n}\r\n\r\n@function zindex($layer) {\r\n    @if not map-has-key($zindex, $layer) {\r\n        @warn 'No z-index found for `#{$layer}`.';\r\n    }\r\n    \r\n    @return map-get($zindex, $layer);\r\n}\r\n","/**\r\n * mixins.scss\r\n * Contains the sitewide mixins\r\n */\r\n\r\n@mixin from-breakpoint($bp) {\r\n    @if ($bp == 'x-small') {\r\n        @content;\r\n    }\r\n    @else {\r\n        @if map-has-key($breakpoints, $bp) {\r\n            $list: map-get($breakpoints, $bp);\r\n            $bp: nth($list, 1);\r\n        }\r\n        \r\n        @media screen and (min-width: #{$bp}) {\r\n            @content;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin font($font-size, $line-height, $font-weight:400, $letter-spacing: 0) {\r\n    font-size: $font-size;\r\n    line-height: $line-height;\r\n    font-weight: $font-weight;\r\n    letter-spacing: $letter-spacing;\r\n}\r\n\r\n@mixin host-block() {\r\n    :host {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@mixin float-left() {\r\n    float: left;\r\n}\r\n\r\n@mixin float-right() {\r\n    float: right;\r\n}\r\n\r\n@mixin btn-link($btnColor: #B73C00, $hoverColor: #7C3813) {\r\n    color: $btnColor;\r\n    font-weight: 600;\r\n\r\n    &:hover {\r\n        color: $hoverColor;\r\n    }\r\n\r\n    &:focus {\r\n        color: $btnColor;\r\n        outline: 2px solid $btnColor;\r\n        outline-offset: 4px;\r\n    }\r\n}\r\n","@import '../abstracts/mixins';\r\n\r\n/**\r\n * global.scss\r\n * Contains the sitewide global styles\r\n */\r\n\r\n* {\r\n    background-repeat: no-repeat;\r\n    box-sizing: border-box;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n    position: relative;\r\n    text-rendering: optimizeLegibility;\r\n\r\n    &:before,\r\n    &:after {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    &:focus {\r\n        outline: 1px dotted #000;\r\n    }\r\n}\r\n\r\nhtml,\r\nbody {\r\n    margin: 0;\r\n    min-height: 100vh;\r\n}\r\n\r\nbody {\r\n    width: 100%;\r\n}\r\n\r\nimg {\r\n    width: 100%;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5 {\r\n    margin: 0;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\nspan,\r\na,\r\nli,\r\np,\r\ninput,\r\ntextarea {\r\n    font-family: inherit;\r\n}\r\n\r\n.clearfix {\r\n    zoom: 1;\r\n\r\n    &:after {\r\n        clear: both;\r\n    }\r\n    \r\n    &:after,\r\n    &:before {\r\n        content: '\\0020';\r\n        display: block;\r\n        overflow: hidden;\r\n        visibility: hidden;\r\n        width: 0;\r\n        height: 0;\r\n    }\r\n}\r\n\r\n.float-left {\r\n    float: left;\r\n}\r\n\r\n.float-right {\r\n    float: right;\r\n}\r\n","/**\r\n * reset.scss\r\n * Contains the sitewide css reset\r\n */\r\n\r\nhtml,\r\nbody,\r\ndiv,\r\nspan,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\npre,\r\nabbr,\r\naddress,\r\naddress,\r\ncite,\r\ncode,\r\ndel,\r\ndfn,\r\nem,\r\nimg,\r\nins,\r\nkbd,\r\nq,\r\nsamp,\r\nsmall,\r\nstrong,\r\nsub,\r\nsup,\r\nvar,\r\nb,\r\ni,\r\ndl,\r\ndt,\r\ndd,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\nlegend,\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd,\r\narticle,\r\naside,\r\ncanvas,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\nsection,\r\nsummary,\r\ntime,\r\nmark,\r\naudio,\r\nvideo {\r\n    background: colors('transparent');\r\n    border: 0;\r\n    font-size: 100%;\r\n    margin: 0;\r\n    outline: 0;\r\n    padding: 0;\r\n    vertical-align: baseline;\r\n}\r\n\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nimg,\r\nmenu,\r\nnav,\r\nsection {\r\n    display: block;\r\n}\r\n\r\nol,\r\nul {\r\n    list-style: none;\r\n}\r\n\r\nblockquote,\r\nq {\r\n    quotes: none;\r\n\r\n    :before,\r\n    :after {\r\n        content: none;\r\n    }\r\n}\r\n\r\na {\r\n    background: colors('transparent');\r\n    font-size: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    text-decoration: none;\r\n    touch-action: manipulation;\r\n    vertical-align: baseline;\r\n}\r\n\r\ntable {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n}\r\n\r\nhr {\r\n    border: 0;\r\n    display: block;\r\n    height: 1px;\r\n    margin: 1em 0;\r\n    padding: 0;\r\n}\r\n\r\ninput,\r\nselect {\r\n    vertical-align: middle;\r\n}\r\n\r\naddress {\r\n    font-style: normal;\r\n}\r\n\r\ninput {\r\n    &::-ms-clear {\r\n        display: none;\r\n    }\r\n}\r\n\r\nbutton {\r\n    background: none;\r\n    border: 0;\r\n    padding: 0;\r\n}\r\n\r\n.aulani {\r\n    .room-ready-terms-and-conditions {\r\n        p a {\r\n            font-weight: 600;\r\n            color: #D04901;\r\n        }\r\n\r\n        &.edit {\r\n            p a {\r\n                color: #B73C00;\r\n            }\r\n        }\r\n    }\r\n}\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font';\r\n@import '../../assets/style/base/colors';\r\n\r\n.details-on-file {\r\n    background: #F4F2EF;\r\n    padding: 36px 36px;\r\n    border-top: $primary-aulani-border;\r\n    border-bottom: $primary-aulani-border;\r\n    margin-left: 0;\r\n\r\n    &.all-sections-on-file {\r\n        margin-left: 0;\r\n\r\n        .details-collapse-wrap {\r\n            .details-heading {\r\n                span.di-checkmark {\r\n                    top: 3px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.details-collapse-wrap {\r\n    .details-heading {\r\n        h2 {\r\n            @include font(24px, 32px, 600);\r\n            font-family: $inspiretwdc-light-font;\r\n            color: $aulani-primary-text-color;\r\n            padding-left: 40px;\r\n        }\r\n\r\n        span {\r\n            font-family: Peptasia-ProfileMDX;\r\n            font-size: 22px;\r\n            color: $border-success-color;\r\n            position: absolute;\r\n            width: 28px;\r\n            top: 10px;\r\n        }\r\n    }\r\n\r\n    .details-collapse {\r\n        display: none;\r\n        @include float-right;\r\n        margin-top: 9px;\r\n        cursor: pointer;\r\n\r\n        p {\r\n            @include font(18px, 27px, 600);\r\n            font-family: $inspiretwdc-roman-font;\r\n            color: $aulani-primary-text-color;\r\n            text-align: right;\r\n            padding-right: 34px;\r\n        }\r\n\r\n        span {\r\n            font-family: Peptasia-ProfileMDX;\r\n            font-size: 20px;\r\n            color: $aulani-primary-text-color;\r\n            position: absolute;\r\n            right: 0;\r\n            top: 4px;\r\n            width: 25px;\r\n        }\r\n    }\r\n}\r\n\r\n.details-collapse-bot {\r\n    width: 128px;\r\n    float: right;\r\n    cursor: pointer;\r\n\r\n    p {\r\n        @include font(18px, 27px, 600);\r\n        font-family: $inspiretwdc-roman-font;\r\n        color: $aulani-primary-text-color;\r\n        text-align: right;\r\n        padding-right: 25px;\r\n    }\r\n\r\n    span {\r\n        font-family: Peptasia-ProfileMDX;\r\n        font-size: 16px;\r\n        color: $aulani-primary-text-color;\r\n        position: absolute;\r\n        right: 0;\r\n        top: 5px;\r\n        width: 20px;\r\n    }\r\n}\r\n\r\n/* For Mobile devices */\r\n@media only screen and (max-width: 767px) {\r\n    .details-collapse-wrap {\r\n        .details-heading {\r\n            h2 {\r\n                @include font(18px, 27px, 600);\r\n                padding-left: 32px;\r\n            }\r\n\r\n            span {\r\n                top: 0px;\r\n            }\r\n        }\r\n\r\n        .details-collapse {\r\n            p {\r\n                @include font(14px, 21px, 600);\r\n            }\r\n        }\r\n    }\r\n\r\n    .details-on-file {\r\n        padding: 24px 24px 58px 24px;\r\n        margin: 0;\r\n    }\r\n\r\n    .details-collapse-bot {\r\n        float: left;\r\n        margin-top: 24px;\r\n\r\n        p {\r\n            @include font(14px, 21px, 600);\r\n        }\r\n\r\n        span.di {\r\n            position: absolute;\r\n            left: 0;\r\n            top: 2px;\r\n            width: 20px;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n@media (min-width: 767px) {\r\n    .details-collapse-wrap {\r\n        .details-heading {\r\n            @include float-left;\r\n            width: 75%;\r\n            margin: 0 0 4px 0;\r\n\r\n            h2 {\r\n                @include font(24px, 32px, 600, 0);\r\n                padding-left: 40px;\r\n            }\r\n\r\n            span {\r\n                font-size: 26px;\r\n                width: 33px;\r\n                top: 1px;\r\n            }\r\n        }\r\n\r\n        .details-collapse {\r\n            display: block;\r\n            margin-top: 0;\r\n        }\r\n    }\r\n\r\n    .details-collapse-bot {\r\n        display: none;\r\n    }\r\n}\r\n","$inspiretwdc-font: 'InspireTWDC';\r\n$inspiretwdc-book-font: 'InspireTWDCBook';\r\n$inspiretwdc-light-font: 'InspireTWDCLight';\r\n$inspiretwdc-medium-font: 'InspireTWDCMedium';\r\n$inspiretwdc-heavy-font: 'InspireTWDCHeavy';\r\n$inspiretwdc-black-font: 'InspireTWDCBlack';\r\n$inspiretwdc-roman-font: 'InspireTWDCRoman';\r\n","// Prefix kng-color to be added for above\r\n// ------------------------------------\r\n// Kingswell Named Colors\r\n// ------------------------------------\r\n$kng-color-white:            #fff;\r\n$kng-color-light-blue:       #ebf6fc;\r\n$kng-color-primary-blue:     #41a7e1;\r\n$kng-color-medium-blue:      #1483bd;\r\n$kng-color-active-dark-blue: #253b56;\r\n$kng-color-inactive-grey:    #a1afc0;\r\n$kng-color-messaging-grey:   #8294aa;\r\n$kng-color-active-grey:      #65778a;\r\n$kng-color-workspace-grey:   #f2f2f2;\r\n$kng-color-medium-grey:      #d9d9d9;\r\n$kng-color-disable-grey:     #e6e2e2;\r\n$kng-color-light-gray:       #f6f5fa;\r\n$kng-color-feather-gray:     #d5d5e0;\r\n$kng-color-charcoal-gray:    #6a7889;\r\n$kng-color-royal-blue:       #0f6fdc;\r\n$kng--color-sunrise-orange:  #e42b0a;\r\n$kng-color-slate-grey:       #8596aa;\r\n$kng-color-sky-blue:         #ebf4fc;\r\n\r\n$kng-color-light-yellow:     #fcf8e3;\r\n$kng-color-dark-yellow:      #c09853;\r\n$kng-color-green:            #6fa623;\r\n$kng-color-alert-orange:     #f63;\r\n$kng-color-primary-green:    #7cb130;\r\n$kng-color-secondary-green:  #008820;\r\n\r\n$kng-color-magic-kingdom:    #1994d7;\r\n$kng-color-water-parks:      #009eb2;\r\n$kng-color-animal-kingdom:   #628d25;\r\n$kng-color-epcot:            #d0662c;\r\n$kng-color-hollywood-studios:#6f46ad;\r\n$kng-color-other-property:   #6f46ad;\r\n$kng-color-black:            #000;\r\n\r\n$kng-color-other-properties-dark-blue: #0a4999;\r\n$kng-color-overlay-background: rgba(0, 0, 0, 0.6);\r\n$kng-color-overlay-background-light: rgba(17, 77, 151, 0.8);\r\n$kng-card-shadow: rgba(37, 59, 86, 0.35);\r\n\r\n// Custom color for DVC SI\r\n$kng-color-primary-workspace-disabled: #bcbcbc;\r\n$kng-color-primary-hover: #8dc74c;\r\n$kng-color-primary-pressed: #5a8822;\r\n$kng-color-secondary-pressed-gray: #f9f9f9;\r\n\r\n$vp-color-medium-blue: #114d97;\r\n$vp-color-green: #00993e;\r\n$vp-color-green-active: #0f6e17;\r\n$vp-color-light-blue: #4171ac;\r\n$wdpr-button-bg: rgba(255, 255, 255, 0.95);\r\n\r\n$kng-color-blue-medium: #0079bc;\r\n$kng-color-dark-grey: #00233c;\r\n$kng-color-black-light:       #888;\r\n$kng-color-black-text:       #555;\r\n\r\n$blue-900: #083c5d;\r\n$blue-000: #f3fdff;\r\n$blue-200: #acd4e7;\r\n$blue-300: #b7e4f7;\r\n$blue-700: #0079bc;\r\n$blue-800: #006096;\r\n$blue-900: #083c5d;\r\n$light-blue: #cee6f2;\r\n\r\n$slate-color: #00233c;\r\n$input-border-color: #918F8C;\r\n$light-black-grey: #607682;\r\n$error-red-color: #AC162C;\r\n$horizontal-line-gray: #c1cfd1;\r\n$horizontal-line-light-gray: #e6edef;\r\n$light-grey-border: #c1cfd1;\r\n$checkbox-select: #008900;\r\n$border-success-color: #61941B;\r\n\r\n$slate-000: #f5fbfc;\r\n$slate-100: #e1eef4;\r\n$slate-200: #cee6f2;\r\n$slate-300: #acd4e7;\r\n$slate-400: #83b0cf;\r\n$slate-500: #6591b5;\r\n$slate-600: #4d79a0;\r\n$slate-700: #35618d;\r\n$slate-800: #063f69;\r\n$slate-900: #00233c;\r\n\r\n$cool-grey-000: #f7fbfc;\r\n$cool-grey-100: #e6edef;\r\n$cool-grey-200: #d3dee2;\r\n$cool-grey-300: #c1cfd1;\r\n$cool-grey-400: #acbac1;\r\n$cool-grey-500: #8fa1aa;\r\n$cool-grey-600: #798e99;\r\n$cool-grey-700: #607682;\r\n$cool-grey-800: #445763;\r\n$cool-grey-900: #2c353d;\r\n\r\n$orange-000: #fff9f8;\r\n$orange-100: #ffeeeb;\r\n$orange-200: #ffe3dc;\r\n$orange-300: #ffcab8;\r\n$orange-400: #ffb199;\r\n$orange-500: #ff8a66;\r\n$orange-600: #ee6034;\r\n$orange-700: #dd3700;\r\n$orange-800: #a82502;\r\n$orange-900: #821c00;\r\n\r\n$checkbox-select: #008900;\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.details-on-file {\r\n    background: #EBF6FC;\r\n    padding: 24px 10px 30px;\r\n    margin-top: 0;\r\n}\r\n\r\n.details-collapse-wrap {\r\n    .details-heading {\r\n        h2 {\r\n            @include font(24px, 48px, 300, 0);\r\n            font-family: $inspiretwdc-light-font;\r\n            color: $wdw-primary-text-color;\r\n            padding-left: 40px;\r\n        }\r\n\r\n        span {\r\n            font-family: Peptasia-ProfileMDX;\r\n            font-size: 26px;\r\n            color: #61941B;\r\n            position: absolute;\r\n            width: 33px;\r\n            top: 9px;\r\n            height: 27px;\r\n        }\r\n    }\r\n\r\n    .details-collapse {\r\n        display: none;\r\n\r\n        @include float-right;\r\n        width: 120px;\r\n        margin-top: 9px;\r\n        cursor: pointer;\r\n\r\n        p {\r\n            @include font(12px, 28px, 700, 0);\r\n            font-family: $inspiretwdc-heavy-font;\r\n            color: $wdw-primary-text-color;\r\n            text-align: right;\r\n            padding-right: 24.5px;\r\n        }\r\n\r\n        span {\r\n            font-family: Peptasia-ProfileMDX;\r\n            font-size: 16px;\r\n            color: $wdw-primary-text-color;\r\n            position: absolute;\r\n            right: 0;\r\n            top: 4px;\r\n            height: 16px;\r\n        }\r\n    }\r\n}\r\n\r\n.details-collapse-bot {\r\n    width: 120px;\r\n    float: right;\r\n    cursor: pointer;\r\n\r\n    p {\r\n        @include font(12px, 28px, 700, 0);\r\n        font-family: $inspiretwdc-heavy-font;\r\n        color: $wdw-primary-text-color;\r\n        text-align: right;\r\n        padding-right: 25px;\r\n    }\r\n\r\n    span {\r\n        font-family: Peptasia-ProfileMDX;\r\n        font-size: 16px;\r\n        color: $wdw-primary-text-color;\r\n        position: absolute;\r\n        right: 0;\r\n        top: 5px;\r\n        height: 16px;\r\n    }\r\n}\r\n\r\n@media (min-width: 767px) {\r\n    .details-on-file {\r\n        padding: 24px 40px 30px;\r\n    }\r\n\r\n    .details-collapse-wrap {\r\n        .details-heading {\r\n            @include float-left;\r\n            width: calc(100% - 120px);\r\n        }\r\n\r\n        .details-collapse {\r\n            display: block;\r\n        }\r\n    }\r\n\r\n    .details-collapse-bot {\r\n        display: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
